<template>
    <div class="topological">
        <div>
            <el-button type="primary" @click="submit" style="float: right" :disabled="disSubmitBtn">保存</el-button>
            <el-button type="primary" @click="isExpand?narrowCanvas():expandCanvas()" style="float: right;margin-right: 20px" >{{isExpand?'缩小':'全屏'}}</el-button>
            <!--<el-button type="primary" @click="changePhysics">物理</el-button>-->
        </div>
        <div class="floatContent" id="floatContent">
            <div class="floatText">
                <p>
                <span v-for="(item,ind) in description" :key=ind>{{item}}</span>
                </p>
                <!--                <div class="floatArrow"></div>-->
            </div>
        </div>
        <!--<router-link :to="{ path: '/showPologicalDetail',-->
        <!--query: { serialNumber:nodeId,callback:hideDetailButton }}">-->
        <el-button type="primary" id="getMoreDetail" @mouseenter="holdDetailButton" @click="getCorrectDetail">更多</el-button>
        <!--</router-link>-->

        <div id="mynetwork"></div>
    </div>
</template>

<script>
    import vis from "vis";
    import service from "./configuration.services"
    import detailForm from "./detailForm.vue"                       // 表单明细
    export default {
        props:{
            serialNumber:String |Number,
            type:String
        },
        components:{detailForm},
        data() {

            return {
                network:null,
                networkData:{},
                dragEndData:{},
                options:{},
                disSubmitBtn:true,
                physics:false,
                serialNum:'',
                nodeId:'',
                detail:{},
                description:{},
                timer:null,
                oFloat:null,
                oButton:null,
                oMyNetwork:null,
                oParent:null,//弹框本身，用于控制弹框是否全屏
                isExpand:false,
                positionSerialNum:'',//移动位置后点击保存时发送的配置项序号，存一次就不能变
            }
        },
        mounted () {
            this.init();
            this.oFloat=document.getElementById('floatContent')
            this.oButton=document.getElementById('getMoreDetail')
            this.oMyNetwork=document.getElementById('mynetwork')
            this.oParent=this.oMyNetwork.offsetParent
        },
        created() {
            this.serialNum=this.serialNumber
            this.positionSerialNum=this.serialNumber
        },
        beforeDestroy(){
//            this.network.destroy();
            this.network = null;
        },

        methods: {
            async init(){
                var container = document.getElementById('mynetwork');
                this.options = {
                    width:'100%',
                    height: '100%',
                    // configure: {
                    //     enabled: true,
                    //     filter: 'nodes.physics,edges,physics',
                    //     container: container,
                    //     showButton: true
                    // },
                    layout: {  // 自动层级布局
                        // improvedLayout:true,
                        // randomSeed: 1,
                        hierarchical:{
                            enabled:false,
                            direction:"LR",
                            sortMethod:"hubsize",
                            // treeSpacing:200,
                        }
                    },
                    physics: {
                        enabled: false,
                        // barnesHut:{
                        //     gravitationalConstant:-2000,
                        //     springLength:95
                        // }
                    },
                    clickToUse:true,
                    nodes: {//node的设置
                        size: 15,
                        shape: 'image',
                        mass:1,
                        scaling:{
                            min:50
                        },
                        chosen:{
                            label(values, id, selected, hovering){
//                                values.color = "yellow"
                            },
                            node(values, id, selected, hovering){
                                // console.log(values);
                            }
                        },
                        margin:{
                            top:50,
                            right:50
                        },
                        color:{
                            border:"red",
                            background:"#000",
                            highlight:{
                                border:"yellow",
                                background:"#fff"
                            },
                            hover:{
                                border:"#000",
                                background:"#fff"
                            }
                        },

                        labelHighlightBold:true,
                        font: {
                            size: 15,
                            color: '#000',
                        },
                        borderWidth: 1,

                    },
                    edges: {//edge的设置
                        dashes:true,
                        title:undefined,
                        value:undefined,
                        // physics:true,
                        smooth:{
                            enabled: true, //设置线是否可弯曲
                            type: 'vertical',//discrete,horizontal,vertical
                            // forceDirection: 'none', //'horizontal', 'vertical', 'none' 该选项仅用于cubicBezier曲线。
                            roundness: 1 // 0 .. 1.0
                        },
                        arrows: {
                            to: { enabled: true, scaleFactor: 0.6 },

                        },
                        scaling:{
                            label:{
                                // min:7,
                                // max:15,
                                maxVisible:100,
                                drawThreshold:7,}
                        },
                        chosen: {
                            edge(values, id, selected, hovering) {
                                // console.log(values);
                                values.color = 'red';
                                // console.log(id);
                                // console.log(values.dashes)
                                // hovering=true
                                // console.log(hovering);
                            },
                            label(values, id, selected, hovering){
                                values.color = 'red';
                                // console.log(id);
                                // console.log(values)
                                // console.log(hovering)

                            }
                        },
                        color: {
                            highlight: 'blue',
                        },
                        font: {
                        },

                    },

                    interaction: {
                        dragNodes: true,
                        dragView: true, // 可拖动整个图
                        zoomView: true,
                        hover:true,
                        keyboard: {
                            enabled: true,
                            speed: {x: 10, y: 10, zoom: 0.02},
                            bindToWindow: true
                        },
                        navigationButtons:true,
                        tooltipDelay:300,
                    },
                    groups: {
                        // ws: {
                        //         //系统定义的形状 dot等 这些官网都可以找到
                        //     shape: "dot",
                        //     color: "white"
                        // }
                    },
                };
                // console.log(this.type)
                let serverStr = ''
                let params = {}
                if(this.type == 'topologyMap'){
                    serverStr = 'topologyMapGraph'
                    params = {
                        topology_id:this.serialNum
                    }
                }else{
                    serverStr = 'getVisList'
                    params = {
                        serialNumber:this.serialNum
                    }
                }
                // console.log(serverStr)
                await service[serverStr](params).then(res => {
                    // console.log('取数据');
                    if(!res) return ;
                    if(!res.nodes) return ;
                    res.nodes.forEach(item => {
                        if(item.x == ''){
                            delete item.x
                        };
                        if(item.y == ''){
                            delete item.y;
                        };
                    })
                    let data = {
                        nodes : new vis.DataSet(res.nodes),
                        edges : new vis.DataSet(res.edges)
                    };
                    this.networkData = {
                        nodes:res.nodes,
                        edges:res.edges
                    };
                    this.network = new vis.Network(container, data, this.options);
                    this.network.setOptions(this.options)

                    //初始化后改变options的physics为true，因为初始化时如果为true，节点nodes位置会被拉伸然后错乱，只有初始化固定好节点位置后，关闭节点physics，打开全局physics才能做到节点nodes不受弹簧edges拉伸影响
                    // this.options={
                    //     ...this.options,
                    //     nodes:{
                    //         ...this.options.nodes,
                    //         physics:false
                    //     },
                    //     physics:{
                    //         "minVelocity": 0.75,
                    //         // stabilization:{
                    //         //     iterations:2000,
                    //         // }
                    //     }
                    // }
                    // this.network.setOptions(this.options)
                    // this.network.stabilize(3000)
                    this.eventMethod();
                }).catch(err => {
                    this.$message.error(err.message);
                });
            },
            eventMethod(){
                // console.log(this.network);
                // console.log(this.networkData);
                let vm = this;
                this.network.on('doubleClick',function (params) {
                    // console.log(params);
                    // console.log(params.nodes[0]);
                    let serialNumber = params.nodes[0];
                    vm.serialNum = serialNumber;
                    if (serialNumber){
                        if (serialNumber.indexOf('Cmd')==-1&&isNaN(serialNumber)){
                            // vm.init()
                            // service.getVisList({serialNumber:serialNumber}).then(res => {
                            //     console.log('gg');
                            //     console.log(vm.network.getPositions([vm.serialNum]));
                            //     // let nodePosition=vm.network.getPositions([vm.serialNum])
                            //     // let nodeX=nodePosition[serialNumber].x
                            //     // let nodeY=nodePosition[serialNumber].y
                            //     res.nodes.forEach(item => {
                            //         if(item.x == ''){
                            //             delete item.x
                            //             // item.x=nodeX
                            //         };
                            //         if(item.y == ''){
                            //             delete item.y;
                            //             // item.y=nodeY
                            //         };
                            //     })
                            //     // vm.network.setData({
                            //     //     nodes:res.nodes,
                            //     //     edges:res.edges
                            //     // })
                            //     let data = {
                            //         nodes : new vis.DataSet(res.nodes),
                            //         edges : new vis.DataSet(res.edges)
                            //     };
                            //     this.networkData = {
                            //         nodes:res.nodes,
                            //         edges:res.edges
                            //     };
                            //     this.network = new vis.Network(container, data, options);
                            //     this.eventMethod();
                            //     console.log(vm.network.getPositions([vm.serialNum]));

                            // })
                        }else{
                            vm.init()
                        }
                    }


                });
                this.network.on('dragging',function (params) {
                    // vm.network.startSimulation()
                    // console.log(params);
                    vm.oButton.style.display='none'
                })
                this.network.on('dragEnd',function (params) {
                    // console.log(params);
                    // vm.network.stopSimulation()
                    if (params.nodes&&params.nodes.length > 0){
                        vm.network.clustering.updateClusteredNode(params.nodes[0], {physics : false});
                    };
                    vm.nodeId=params.nodes.length!==0?params.nodes[0]:''
                    // console.log(vm.nodeId);
                    let serialNumber=vm.nodeId
                    if (serialNumber.indexOf('Cmd')==-1&&isNaN(serialNumber)){

                    }else{
                        let offsetX=params.pointer.DOM.x
                        let offsetY=params.pointer.DOM.y
                        if(serialNumber){//防止在空白处拖动全屏的时候也显示‘更多’按钮
                            vm.showDetailButton(offsetX,offsetY)
                        }
                    }

                    vm.dragEndData = {...vm.network.getPositions()}
                    // console.log(vm.dragEndData);
                    vm.disSubmitBtn = false;

                })
                this.network.on('hoverEdge',function (params) {
                    // console.log(params);
                    let networkEdges=vm.networkData.edges
                    let edgeId=params.edge
                    let offsetX=params.pointer.DOM.x
                    let offsetY=params.pointer.DOM.y
                    networkEdges.forEach(item=>{
                        if (edgeId==item.id){
                            vm.showDescription(item.description,offsetX,offsetY)
                        }
                    })

                })
                this.network.on('blurEdge',function (params) {
                    vm.oFloat.style.display='none'

                })
                this.network.on('hoverNode',function (params) {
                    clearTimeout(vm.timer)
                    let serialNumber=params.node
                    if (serialNumber.indexOf('Cmd')==-1&&isNaN(serialNumber)){
                        // console.log(params);
                        // vm.init()
                        // service.getVisList({serialNumber:serialNumber}).then(res => {
                        //     console.log('gg');
                        //     console.log(vm.network.getPositions([vm.serialNum]));
                        //     // let nodePosition=vm.network.getPositions([vm.serialNum])
                        //     // let nodeX=nodePosition[serialNumber].x
                        //     // let nodeY=nodePosition[serialNumber].y
                        //     res.nodes.forEach(item => {
                        //         if(item.x == ''){
                        //             delete item.x
                        //             // item.x=nodeX
                        //         };
                        //         if(item.y == ''){
                        //             delete item.y;
                        //             // item.y=nodeY
                        //         };
                        //     })
                        //     // vm.network.setData({
                        //     //     nodes:res.nodes,
                        //     //     edges:res.edges
                        //     // })
                        //     let data = {
                        //         nodes : new vis.DataSet(res.nodes),
                        //         edges : new vis.DataSet(res.edges)
                        //     };
                        //     this.networkData = {
                        //         nodes:res.nodes,
                        //         edges:res.edges
                        //     };
                        //     this.network = new vis.Network(container, data, options);
                        //     this.eventMethod();
                        //     console.log(vm.network.getPositions([vm.serialNum]));

                        // })
                    }else{
                        vm.oButton.style.display='block'
                        // console.log(vm.networkData);
                        // console.log(params);
                        // let networkNodes = vm.networkData.nodes
                        vm.nodeId=serialNumber
                        // console.log(vm.network.getBoundingBox(nodeId));
                        // networkNodes.forEach(item=>{
                        //     if (nodeId==item.id){
                        //         vm.showDetail(item.label)
                        //     }
                        // })
                        let offsetX=params.pointer.DOM.x
                        let offsetY=params.pointer.DOM.y
                        vm.showDetailButton(offsetX,offsetY)
                    }


                })
                this.network.on('blurNode',function (params) {
                    vm.timer=setTimeout(()=>{
                        vm.hideDetailButton()
                    },1000)
                })

                this.network.on('showPopup',function (params) {
                    // console.log(params,'showPopup');
                })
            },
            showDescription(val,x,y){
                // console.log(val);//description
                let des=val
                des=des.replace(/\n/g,"<br/>")
                // console.log(des);
                this.description=des.split("<br/>")
                // console.log(this.description);
                this.oFloat.style.left=x-15+'px'
                this.oFloat.style.top=y+60+'px'
                this.oFloat.style.display='block'

            },
            showDetailButton(x,y){
                this.oButton.style.left=x+'px'
                this.oButton.style.top=y+40+'px'
                this.oButton.style.display='block'

            },
            hideDetailButton(){
                this.oButton.style.display='none'
            },
            //鼠标划上更多按钮时保持显示
            holdDetailButton(){
                clearTimeout(this.timer)
                this.oButton.style.display='block'
            },
            //点击更多时，判断是配置项还是应用，获取对应的详情
            getCorrectDetail(){
                // console.log(this.nodeId);
                // console.log(isNaN(this.nodeId));
                if (isNaN(this.nodeId)){
                    this.$router.push({
                        path:'/showPologicalDetail',//显示配置项详情页面
                        query: { serialNumber:this.nodeId,callback:this.hideDetailButton }
                    })
                }else{
                    // console.log(this.nodeId);
                    this.$router.push({
                        path:'/showAppDetail',//显示应用详情页面
                        query:{appId:this.nodeId,callback:this.hideDetailButton}
                    })
                }
            },
            changePhysics(){
                this.options={
                    ...this.options,
                    nodes:{
                       ...this.options.nodes,
                        physics:false
                    },
                    physics:{
                        "minVelocity": 0.75
                    }
                }
                // this.options={
                //     ...this.options,
                //
                //     edges:{
                //         ...this.options.edges,
                //         smooth:{
                //             enabled: true, //设置线是否可弯曲
                //             type: 'dynamic',//discrete,horizontal,vertical
                //             // forceDirection: 'none', //'horizontal', 'vertical', 'none' 该选项仅用于cubicBezier曲线。
                //             roundness: 1 // 0 .. 1.0
                //         },
                //
                //     },
                //     // physics:{
                //     //     "minVelocity": 0.75
                //     // }
                // }
                this.network.setOptions(this.options)
                // console.log('setOption');
            },
            //点击全屏按钮放大画布
            expandCanvas(){
                // console.log(1);
                this.isExpand=true
                // let parent=this.oMyNetwork.offsetParent
                this.oParent.style.width='100%'
                this.oParent.style.height='100%'
                this.oParent.style.maxHeight='100%'
                this.oMyNetwork.style.height='100%'
                // console.log(parent);
            },
            narrowCanvas(){
                this.isExpand=false
                this.oParent.style.width='900px'
                this.oParent.style.height=null
                this.oParent.style.maxHeight='90%'
                this.oMyNetwork.style.height='800px'
            },
            submit(){
                let data = Object.keys(this.dragEndData);
                let networkData = this.networkData.nodes;
                // console.log(networkData)
                // console.log(data)
                // console.log(this.dragEndData)
                let vm = this;
                if(data.length > 0){
                    // 位置变化，保存位置
                    networkData.forEach(item => {
                        data.forEach((d,i)=> {
                            if( item.id == d ){
                                item.x = vm.dragEndData[d].x;
                                item.y = vm.dragEndData[d].y;
                            }
                        })
                    });
                    let graphData = {
                        ...vm.networkData,
                        nodes:networkData
                    };
                    let params = {
                        // serialNumber:vm.positionSerialNum,
                        topology_id:vm.positionSerialNum,
                        graphData:graphData,
                    };
                    // console.log(params)
                    // service.saveTopological(params).then(res => {
                    //     this.$message.success("位置保存成功");
                    //     this.disSubmitBtn = true;
                    //     // this.$modal.close();
                    // }).catch(err => {
                    //     this.$message.error(err.message);
                    // })
                    service.saveTopologicalNew(params).then(res => {
                        this.$message.success("位置保存成功");
                        this.disSubmitBtn = true;
                        // this.$modal.close();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                }else{
                    // 没被拖拽过，位置没变化
                    this.disSubmitBtn = true;
                }
            }
        }
    }
</script>
<style scoped>
    /deep/.vis-navigation div{
        /*display: none;*/
        visibility: hidden;

    }
    /deep/.vis-navigation .vis-button.vis-zoomExtends{
        /*display: none;*/
        touch-action: pan-y;
        visibility: visible;
        user-select: none;
        position: absolute;
        top: 0;
        right: 0!important;
        -webkit-user-drag: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
    #getMoreDetail{
        position: absolute;
        z-index: 999;
        display: none;
    }

    .floatContent{
        position: absolute;
        background: white;
        z-index: 999;
        display: none;
    }
    .floatText{
        display: block;
        min-width: 50px;
        max-width: 280px;
        /*background: green !important;*/
        border: 1px solid grey;
        position: relative;
        box-shadow: 3px 2px 7px #888888;
    }
    .floatText p{
        word-wrap: break-word;
        word-break: break-all;
    }
    .floatText p span{
        display: block;
    }
    .floatArrow{
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 10px 0 10px;
        border-color: grey transparent transparent transparent;
        position: absolute;
        bottom: -10px;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
    .floatArrow:after{
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        top: -12px;
        left: -10px;
        border-width: 10px 10px 0 10px;
        border-style: solid;
        border-color: white transparent transparent transparent;
    }
    #detailForm_network{
        position: absolute;
        top: 0;
        left: 0;
        z-index:999
    }

</style>
<style lang="scss" scoped rel="stylesheet/scss">
    @import "~vis/dist/vis.css";
    .topological{
        width:100%;
        height: 100%;
    }
    #mynetwork {
        width: 100%;
        height: 800px;
    }
</style>
